<template>
  <helper-layout :loaded="mx_loaded">
    <material-table
      :items="histories"
      :headers="headers"
      :paginate="paginateConfig"
      :search-data="searchData"
      :sort-data.sync="sortData"
      :total-count="accountHistories.totalCount"
      @pageChange="handlePageChange"
      @sortChange="handleSortChange"
      @selectChange="handleSelectChange"
      @searchChange="handleSearchChange"
    />
    <material-dialog
      :visible="showInfoDialog"
      :show-close="false"
      width="800"
      :submit-color="color"
      :title="getInfoDialogTitle(order)"
      @confirmFn="handleSubmitDialog('cancle')"
      @cancleFn="handleCloseDialog('cancle')"
    >
      <!-- :show-sure="!getShowUndoButton(order)" :confirm-text="$t('Views.Finance.cancel')"-->
      <template>
        <div
          class="print-footer"
          style="width:100%;"
        >
          <div style="width:100%; margin-top:10px;">
            <label class="print-item-title">{{ $t("Views.Finance.client") }}</label><label>：</label>
            <span class="print-item-value">{{ order && order.customer ? order.customer.name : "" }}</span>
<!--            <label class="width-98">{{ $t("Views.Finance.serialNumber") }}</label><label>：</label>-->
<!--            <span class="print-item-value">{{ order && order.customer && order.customer.serialNumber ? order.customer.serialNumber : "" }}</span>-->
          </div>

          <div style="width:100%; margin-top: 10px;">
            <label class="width-146">{{ $t("Views.Finance.serialNumber") }}</label><label>：</label>
            <span class="print-item-value_serial">{{ order && order.customer && order.customer.serialNumber ? order.customer.serialNumber : "" }}</span>
            <label class="width-159">{{ $t("Views.Finance.newSerialNumber") }}</label><label>：</label>
            <span class="print-item-value_serial">{{ order && order.customer && order.customer.newSerialNumber ? order.customer.newSerialNumber : "" }}</span>
          </div>

          <div style="width:100%; margin-top:10px;">
            <label class="print-item-title">{{ $t("Views.Finance.sales") }}</label><label>：</label>
            <span class="print-item-value">{{ order && order.salesStr ? order.salesStr : "" }}</span>
            <label class="width-126">{{ $t("Views.Finance.accountName") }}</label><label>：</label>
            <span class="print-item-value">{{ order ? getAccountName(order.accountName) : "" }}</span>
          </div>

          <div style="width:100%; margin-top:10px;">
            <label class="print-item-title">{{ $t("Views.Finance.operationType") }}</label><label>：</label>
            <span class="print-item-value">{{ order ? order.operateName : "" }}</span>
            <!-- <label class="width-98">{{ $t("Views.Finance.accountName") }}</label><label>：</label>
            <span class="print-item-value">{{ order ? getAccountName(order.accountName) : "" }}</span> -->
            <label class="width-126">{{ $t("Views.Finance.accountBlance") }}</label><label>：</label>
            <span class="print-item-value">{{ order ? order.balance : "" }}</span>
          </div>

          <div v-if="order && order.operateType === 'Recharge'&&order.paymentMethodName " style="width:100%; margin-top:10px;">
            <label v-if="order && order.operateType === 'Recharge'" class="print-item-title">{{ $t("Views.Finance.recharge_method") }}</label>
            <label v-if="order && order.operateType === 'Recharge'">：</label>
            <span v-if="order && order.operateType === 'Recharge'" class="print-item-value">{{ order ? order.paymentMethodName : "" }}</span>
            <label :class="order && order.operateType === 'Recharge'?'width-99':'print-item-title'">{{ $t("Views.Finance.amount") }}</label><label>：</label>
            <span class="print-item-value">{{ order ? order.amountDisplay : "" }}</span>
            <!-- 冻结金额 -->
            <!-- <label class="print-item-title">{{ $t("Views.Finance.freezeAmount") }}</label><label>：</label>
            <span class="print-item-value">{{ order ? order.freezeAmount : "" }}</span> -->
          </div>

          <div v-if=" !(order && order.paymentMethodName)" style="width:100%; margin-top:10px;">
            <label :class="order && order.operateType === 'Recharge'?'width-99':'print-item-title'">{{ $t("Views.Finance.amount") }}</label><label>：</label>
            <span class="print-item-value">{{ order ? order.amountDisplay : "" }}</span>
            <label class="print-item-title">{{ $t("Views.Finance.freezeAmount") }}</label><label>：</label>
            <span class="print-item-value">{{ order ? order.freezeAmount : "" }}</span>
            <!-- <label class="width-98">{{ $t("Views.Finance.accountBlance") }}</label><label>：</label>
            <span class="print-item-value">{{ order ? order.balance : "" }}</span> -->
          </div>
          <div v-else style="width:100%; margin-top:10px;">
            <label class="print-item-title">{{ $t("Views.Finance.freezeAmount") }}</label><label>：</label>
            <span class="print-item-value">{{ order ? order.freezeAmount : "" }}</span>
          </div>

          <div style="width:100%; margin-top:10px;">
            <label class="print-item-title">{{ $t("Views.Finance.creationTime") }}</label><label>：</label>
            <span class="print-item-full-value">
              {{ order ? formatDateTime(order.creationTime, 'YYYY-MM-DD HH:mm:ss') : "" }}
              {{ order ? order.creatorName : "" }}
            </span>
          </div>
          <div
            v-show="getShowAttchment(order ? order.operateType : '')"
            style="width:100%; margin-top:10px;"
          >
            <label class="print-item-title">{{ $t("Views.Finance.dateTime") }}</label><label>：</label>
            <span class="print-item-full-value">
              <!-- order ? order.operateType === 'ManualRecharge' -->
              {{
                order ? order.operateType === 'Recharge' ? formatDateTime(order.operateTime, 'YYYY-MM-DD') : formatDateTime(order.creationTime, 'YYYY-MM-DD HH:mm:ss') : "" }}
              {{ order ? order.creatorName : "" }}
            </span>
          </div>
          <div style="width:100%; margin-top:10px;">
            <label class="print-item-title">{{ $t("Views.Finance.remark") }}</label><label>：</label>
            <span class="print-item-full-value">{{ order ? order.remark : "" }}</span>
          </div>

          <!-- <div
            v-show="getShowAttchment(order ? order.operateType : '')"
            style="width:100%; margin-top:10px;"
          >
            <label class="print-item-title">{{ $t("Views.Finance.attachment") }}：</label>
            <label
              v-show="order && order.pictureKey && order.pictureKey != ''"
              class="print-item-full-value"
            >
              <material-img :preview="true" :picture-key="order ? order.pictureKey : ''" />
            </label>
          </div> -->

          <div
            v-show="getShowUndoReason(order ? order.operateType : '')"
            style="width:100%; margin-top:10px;"
          >
            <label class="print-item-title">{{ $t("Views.Finance.reason") }}</label><label>：</label>
            <span class="print-item-full-value">{{ order ? order.undoReason : "" }}</span>
          </div>
        </div>
      </template>
    </material-dialog>
  </helper-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { pageLoadMx } from '@/plugins/mixins'
import ENUMS from '@/dict/enums'
import { format } from 'date-fns'

export default {
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      headers: [
        // {
        //   text: $t('Views.Finance.customer_search_label'),
        //   value: 'customerInfo',
        //   align: 'left',
        //   renderHeader: (h, params) => {
        //     return h(
        //       'div',
        //       {
        //         domProps: {
        //           innerHTML: $t('Views.Order.clientName') + '<br/>' + $t('Views.Order.customerNum')
        //         }
        //       }
        //     )
        //   },
        //   render: (h, param) => {
        //     const text = param.row.customer.name + (param.row.customer.serialNumber ? '<br />' + param.row.customer.serialNumber : '')
        //     return h('div', {
        //       domProps: {
        //         innerHTML: text
        //       }
        //     })
        //   }
        // },
        { // 客户名称 新客户编码
          text: $t('Views.Finance.customer_search_label'),
          value: 'customerInfo',
          align: 'left',
          renderHeader: (h, params) => {
            return h(
              'div',
              {
                domProps: {
                  innerHTML: $t('Views.Order.clientName') + '<br/>' + $t('Views.Order.newCustomerNumList')
                }
              }
            )
          },
          render: (h, param) => {
            const text = param.row.customer ? param.row.customer.name + (param.row.customer.newSerialNumber && param.row.customer.serialNumber ? '<br />' +
              param.row.customer.newSerialNumber : param.row.customer.newSerialNumber ? '<br />' + param.row.customer.newSerialNumber : '<br />' + param.row.customer.serialNumber) : '--'
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          text: $t('Views.Finance.sales'),
          value: 'customerSale',
          render: (h, param) => {
            return h('div', param.row.customer.sale && param.row.customer.sale.staff.name)
          }
        },
        { text: $t('Views.Finance.operateNumber'), value: 'number' },
        { text: $t('Views.Finance.operateDate'), type: 'date', value: 'lastModificationTime' },
        { text: $t('Views.Finance.operationType'), value: 'operateName' },
        {
          text: $t('Views.Finance.accountName'),
          value: 'accountName',
          render: (h, params) => {
            return h('div', ENUMS.systemAccountNames[params.row.accountName])
          }
        },
        {
          text: $t('Views.Finance.amount'),
          // value: 'amount',//字体要黑色 就这个表特殊
          align: 'right',
          render: (h, params) => {
            return h('div',
              `${params.row.amount < 0 ? '-' : '+'}${params.row.accountName === 'JPY' ? '￥' : '$'}${this.$util.data.toThousands(Number(String(params.row.amount).replace('-', ''))) || this.$util.data.toThousands(params.row.amount)}`
            )
          }
        },
        {
          text: $t('Views.Finance.accountFreeze'),
          value: 'freezeAmount',
          align: 'right',
          render: (h, params) => {
            return h('div', this.$util.data.moneyFmt(params.row.freezeAmount, params.row.accountName))
          }
        },
        {
          text: $t('Views.Finance.accountBlance'),
          value: 'balance',
          align: 'right',
          render: (h, params) => {
            return h('div', this.$util.data.moneyFmt(params.row.balance, params.row.accountName))
          }
        },
        {
          text: $t('Views.Finance.action'),
          value: 'action',
          actions: [
            {
              actionFn: (row) => {
                this.onDetailClick(row.row)
              },
              text: $t('Views.Finance.view'),
              color: this.$store.state.app.color,
              visible: true
            }
          ]
        }
      ],
      searchData: [
        {
          key: 'customerFilter',
          value: '',
          itemValue: '',
          label: $t('Views.Finance.customer_search_label'),
          placeholder: $t('Views.Finance.nameOrSN')
        },
        {
          key: 'saleId',
          name: $t('Views.Finance.sales'),
          placeholder: $t('Views.Customer.selectSales'),
          type: 'select',
          itemText: 'name',
          itemValue: 'id',
          id: '',
          state: []
        },
        {
          key: 'dateRange',
          type: 'daterange',
          label: $t('Views.Finance.operateDate'),
          value: {},
          icon: 'mdi-calendar'
        },
        {
          key: 'operateType',
          name: $t('Views.Finance.operationType'),
          placeholder: $t('Views.Finance.selectType'),
          type: 'select',
          itemText: 'name',
          itemValue: 'id',
          id: '',
          state: []
        },
        {
          key: 'accountId',
          name: $t('Views.Finance.accountName'),
          placeholder: $t('Views.Finance.selectAccount'),
          type: 'select',
          itemText: 'name',
          itemValue: 'id',
          id: '',
          state: []
        }
      ],
      paginateConfig: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      sortData: {
        descending: false
      },
      form: {
        customerFilter: '',
        saleId: '',
        // beautyAdvisorId: '',
        operateType: '',
        accountId: '',
        sorting: '',
        skipCount: 0,
        maxResultCount: 10
      },
      histories: [],
      // 表格行已选数据
      selectData: [],
      showInfoDialog: false,
      showConfirmDialog: false,
      undoReason: '',
      order: null,
      selectAccount: []
    }
  },
  computed: {
    color() {
      return this.$store.state.app.color
    },
    ...mapState('finance', ['accountHistories', 'systemAccountList', 'history']),
    ...mapState('setting', ['staffAllData']),
    enableSubmitButton() {
      return this.undoReason !== '' && this.undoReason.length <= 50
    },
    undoReasonRules() {
      if (this.undoReason === '') {
        return [this.$util.rules.emptyRule(this.$t('Views.Finance.reason'))]
      } else {
        return []
      }
    },
    operationList() {
      const opList = []
      for (const i in ENUMS.OperationNames) {
        opList.push({ id: i, name: ENUMS.OperationNames[i] })
      }
      return opList
    }
  },
  mounted() {
    if (this.$route.params.item) {
      this.selectAccount = this.$route.params.item
      const accountName = this.selectAccount['Customer.CustomerNewInfo'].replace(/\\r\\n/g, ' ').split(' ')[0]
      this.form.customerFilter = accountName
      this.searchData[0].value = accountName
    }
    this.getStaff()
    this.getAccount()
    this.getPage()
  },
  methods: {
    ...mapActions('finance', ['getAccountHistories', 'getSystemAccountList', 'getHistory', 'undoAccount']),
    ...mapActions('setting', ['getStaffAllData']),
    getStaff() {
      this.getStaffAllData({ isActive: true, permissionCheck: true })
        .then(() => {
          this.searchData[1].state = this.staffAllData.items
          this.mx_loaded_fn()
        }).finally(() => {
          this.mx_loaded_fn()
        })
    },
    getAccount() {
      this.getSystemAccountList()
        .then(() => {
          this.searchData[4].state = this.systemAccountList.items.map(i => {
            i.name = ENUMS.systemAccountNames[i.name]
            return i
          })
          this.mx_loaded_fn()
        }).finally(() => {
          this.mx_loaded_fn()
        })
    },
    getHistories() {
      this.getAccountHistories(this.form).then(() => {
        this.histories = this.accountHistories.items
        this.paginateConfig.total = this.accountHistories.totalCount
        this.accountHistories && this.accountHistories.items.map(v => {
          v.operateTime = format(new Date(v.operateTime), 'YYYY-MM-DD')
          v.operateName = ENUMS.OperationNames[v.operateType]
        })
        this.mx_loaded_fn()
      }).finally(() => {
        this.mx_loaded_fn()
      })
    },
    getPage(page) {
      if (typeof page !== 'undefined') {
        this.paginateConfig.page = page
        this.form.skipCount = (page - 1) * this.form.maxResultCount
      }
      if (!this.mx_loaded) this.mx_loading_fn() // 页面加载中
      this.searchData[3].state = this.operationList
      this.getHistories()
    },
    handleSearchChange(search) {
      this.form = { ...this.form, ...search }
      if (search.dateRange) {
        this.form = { ...this.form, ...{ operateStartTime: search.dateRange.start }, ...{ operateEndTime: search.dateRange.end }}
      }
      delete this.form.dateRange
      this.getPage(1)
    },
    handlePageChange(page) {
      this.getPage(page)
    },
    handleSortChange(sort) {
      const value_sort = `${sort.sortBy}`
      const value_desc = sort.descending ? ' desc' : ''
      const value = value_sort + value_desc
      if (value === this.form.sorting) return
      this.form.sorting = value
      this.getPage()
    },
    handleSelectChange(selected) {
      this.selectData = selected
    },
    getInfoDialogTitle(order) {
      if (!order) return ''
      const head = this.$t('Views.Finance.orderNumber') + `${order.number}`
      if (order.operateType === 'Recharge' && !order.canUndo) {
        return `${head}（${this.$t('Views.Finance.canceled')}）`
      } else {
        return head
      }
    },
    /** 详情弹窗 是否撤销原因 */
    getShowUndoButton(order) {
      if (!order) return true
      if (this.$util.tool.hasPerm('FinanceManager.RechargeList.UndoRecharge')) {
        return !order.canUndo
      } else {
        return true
      }
    },
    /** 点击弹框的取消 */
    handleCloseDialog(type) {
      switch (type) {
        case 'cancle':
          this.showInfoDialog = false
          break
        case 'confirm':
          this.undoReason = '';
          (this.$refs.undoReasonForm).resetValidation()
          this.showConfirmDialog = false
          break
        default:
          break
      }
    },
    /** 点击弹框的确定 */
    handleSubmitDialog(type) {
      switch (type) {
        case 'cancle':
          this.showInfoDialog = false
          break
        case 'confirm':
          if ((this.$refs.undoReasonForm).validate()) {
            const params = {
              id: this.order.id,
              reason: this.undoReason
            }
            this.undoAccount(params)
              .then(() => {
                this.showConfirmDialog = false
                this.showInfoDialog = false
                this.undoReason = ''
                this.$store.commit('app/setNotification', { msg: this.$t('Views.Finance.successCanceled'), type: 'success' })
                this.getHistories()
              })
              .catch(error => {
                this.$store.commit('app/setNotification', { msg: error.error.message, type: 'error' })
              })
          }
          break
        default:
          break
      }
    },
    /** 详情弹窗 是否撤销原因 */
    getShowUndoReason(type) {
      // 撤消充值
      return type === 'UndoRecharge'
    },
    /** 详情弹窗 是否显示附件 */
    getShowAttchment(type) {
      // 充值
      return type === 'Recharge'
      // return type === 'Recharge' || type === 'ManualRecharge'
    },
    formatDateTime(date, fmt) {
      return format(date, fmt)
    },
    /** 详情弹窗 时间 显示的标题 */
    getTimeTitle(type) {
      switch (type) {
        case 'Recharge': // / 充值
        case 'FreezeDifference': // / 冻结金额差值
        case 'OrderFreeze': // / 下单冻结
          return this.$t('Views.Finance.creationTime')

        case 'CancelDeduct': // / 取消扣款
        case 'UndoRecharge': // / 撤消充值
          return this.$t('Views.Finance.cancelTime')

        case 'CancelFreeze': // / 取消冻结
        case 'Deduct': // / 扣款
          return this.$t('Views.Finance.reduceTime')
        default:
          // Transfer 转账
          return this.$t('Views.Finance.creationTime')
      }
    },
    /** 选中了某一项的详细 */
    onDetailClick(item) {
      if (item && item.id && item.id !== '') {
        this.getHistory(item.id)
          .then(() => {
            this.order = this.history
            this.order.creationTime = format(this.order.creationTime, 'YYYY-MM-DD HH:mm:ss')
            this.order.operateName = ENUMS.OperationNames[this.order.operateType]
            this.order.showUndoReason = this.order.operateType === 'UndoRecharge'
            if (this.order.customer && this.order.customer.sale) this.order.salesStr = this.order.customer.sale.staff.name || ''// this.getNamesStrByList(this.order.customer.sales)
            if (this.order.customer && this.order.customer.beautyAdvisors) this.order.beautyAdvisorsStr = this.getNamesStrByList(this.order.customer.beautyAdvisors)

            this.order.amountDisplay = `${this.order.amount < 0 ? '-' : '+'}${this.order.accountName === 'JPY' ? '￥' : '$'}${this.$util.data.toThousands(Number(String(this.order.amount).replace('-', ''))) || this.$util.data.toThousands(this.order.amount)}`

            this.order.freezeAmount = this.$util.data.moneyFmt(this.order.freezeAmount, this.order.accountName)
            this.order.balance = this.$util.data.moneyFmt(this.order.balance, this.order.accountName)

            this.showInfoDialog = true
          })
          .catch(error => {
            this.$store.commit('app/setNotification', { msg: error, type: 'error' })
          })
      }
    },
    getNamesStrByList(items) {
      if (!items) {
        return ''
      }
      if (items.length <= 0) {
        return ''
      }
      let str = ''
      items.map((v) => {
        if (v.staff && v.staff.name) {
          str = v.staff.name + ',' + str
        }
      })
      str = str.substring(0, str.length - 1)
      return str
    },
    getAccountName(name) {
      return ENUMS.systemAccountNames[name]
    }
  }
}
</script>

 <style lang="scss" scoped>

.print-footer{
  div{
    label{
      display: inline-block;
      text-align: left;
      // padding: 0 10px 0 0;
      vertical-align: top;
      font-size: 14px;
      font-weight: bold;
      color: #515151;
    }
  }
}
.width-159 {
  width: 159px;
}
.print-item-title {
  width: 85px;
}
.print-item-value {
  width: calc(calc(100% - 250px) / 2);
  display: inline-block;
  vertical-align: top;
  word-wrap: break-word;
  font-size: 14px;
  &.red-num {
    color: #FF0000;
  }
}
.print-item-value_serial {
  width: calc(calc(100% - 372px) / 2);
  display: inline-block;
  vertical-align: top;
  word-wrap: break-word;
  font-size: 14px;
  &.red-num {
    color: #FF0000;
  }
}
.print-item-full-value {
  width: calc(100% - 160px);
  display: inline-block;
  vertical-align: top;
  word-wrap: break-word;
  font-size: 14px;
}
.fix-left {
  margin-left: 10px;
}
.fix-right {
  margin-right: 10px;
}
.fix-top {
  margin-top: 10px;
}
.attchment-img {
  width: 100%;
}
.fix-search-item {
  margin-top: 20px;
  margin-left: 10px;
}
.width-99{
  width:98px;
}
.width-85{
  width:85px;
}
.width-146 {
  width:146px;
}
.width-126 {
  width:126px;
}
</style>
